import { render } from "./B2bFilterButtonProfiles.vue?vue&type=template&id=ac7fec68&scoped=true&lang=pug"
import script from "./B2bFilterButtonProfiles.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonProfiles.vue?vue&type=script&lang=js"

import "./B2bFilterButtonProfiles.vue?vue&type=style&index=0&id=ac7fec68&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7fec68"]])

export default __exports__